// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__14WO1","header":"ReportDetails_header__1Kyac","title":"ReportDetails_title__19IoI","left":"ReportDetails_left__1GBxT"};